<template>
  <div class="infobit pointable" :tabindex="tabIndex" :style="css" @click="select"
      :title="typeDef.name + ' ID: ' + infobit.id">
    <div :class="['icon', 'fa', 'fa-fw', iconClass]" :style="css"></div>
    <div :class="['title', {highlight: isSelected}]">{{infobit.title}}</div>
    <div class="button-panel">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {

  props: ['infobit', 'tabIndex'],

  computed: {

    typeDefs () {
      return this.$store.state.typeDefs
    },

    typeDef () {
      return this.typeDefs[this.infobit.type]
    },

    isSelected () {
      return this.$store.state.infobitId === this.infobit.id
    },

    iconClass () {
      return 'fa-' + this.$store.state.typeDefs[this.infobit.type].icon
    },

    css () {
      return this.$store.state.typeDefs[this.infobit.type].css
    }
  },

  methods: {
    select () {
      if (this.$el && this.$el.tabIndex) {
        this.$nextTick(function () {
          this.$el.focus()
        })
      }
      this.$store.dispatch('selectInfobit', this.infobit.id)
    }
  }
}
</script>

<style>

.infobit {
  display: flex;
  align-items: baseline;
  flex: auto;
  position: relative;   /* setup new coordinate system for absolutely positioned child (the button panel) */
  border-bottom: 1px solid var(--grey-border);
}

.infobit:hover {
  background-color: var(--infobit-hover-color);
}

.infobit .icon {
  flex: none;
}

.infobit .title {
  line-height: 1.3em;
  margin-left: 0.2em;
}

.infobit .button-panel {
  position: absolute;
  background-color: white;
  right: 0;
  bottom: 0;
  visibility: hidden;
}

.infobit:hover .button-panel {
  visibility: visible;
}

.infobit .button-panel button {
  color: var(--hotspot-color);
  border: 1px solid var(--grey-border);
  width: 2em;
  margin-top: 2px;      /* Safari default, but Chrome and Firefox has 0 */
  margin-bottom: 2px;   /* Safari default, but Chrome and Firefox has 0 */
  padding-top: 2px;     /* Chrome and Safari default, but Firefox has 0 */
  padding-bottom: 3px;  /* Chrome and Safari default, but Firefox has 0 */
}

.infobit .button-panel button:enabled:hover {
  color: var(--hotspot-hover-color);
  cursor: pointer;
}

.infobit.no-events {
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// infobit.vue?090f60e0